export const HEADER_TRANSPARENT_LIGHT_VARIANT = 'transparentLight'
export const HEADER_TRANSPARENT_VARIANTS_PREFIX = 'transparent'
export const HEADER_STYLE_VARIANTS = {
    basic: '',
    'transparent light': HEADER_TRANSPARENT_LIGHT_VARIANT,
    'transparent dark': 'transparentDark'
}
export const HEADER_PDC_PAGE_ID = 'header'
export const HEADER_TRANSPARENT_SCROLLED_VARIANT = 'basicAbsolute'
